import { useTexts } from './useTexts'
import { form } from '../formState'

export function StartEndRoute() {
  const texts = useTexts()

  return (
    <form.Fieldset>
      <form.Checkbox
        label={texts.header.title}
        name="collectStartEndRoute"
        validateOn="blur change"
        testId="collect-start-end-route"
        helperText={texts.header.description}
      />
    </form.Fieldset>
  )
}
